
import { defineComponent } from "vue";
import Dropdown1 from "@/components/dropdown/Dropdown1.vue";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String
  },
  components: {
    Dropdown1
  },
  data() {
    return {
      dateRangeLabel: "18 Oct 2026 - 18 Nov 2026",
      rangePreset: ""
    };
  }
});
